export const updateDatiModPagAltro = (unDato, unActionType) => {
    return {
      type: unActionType,
      unDato,
    }
  };